import EventBus from '@/components/mixins/event-bus-mixin'

export default {
  inject: [
    '$utils'
  ],
  data () {
    return {
      expanded: false,
      commonExpandActionsDefaultSliderHeight: 43,
      showExpandIcon: false,
      componentNames: Object.freeze({
        TAGS_SLIDER: 'tagSlider',
        LED_TAGS_SLIDER: 'ledPageTagSlider',
        POPID_SLIDER: 'popIdSlider',
        MEDIA_PICKER: 'mediaListInModal'
      })
    }
  },
  methods: {
    isMediaListModalVisible () {
      return ($('#mediaList').length && $('#mediaList').hasClass('visible'))
    },
    tagSliderEl () {
      if (this.isMediaListModalVisible()) {
        return this.mediaListEl().find('#tagSlider')
      }

      return $('#tagSlider')
    },
    ledSliderEl () {
      if (this.isMediaListModalVisible()) {
        return this.mediaListEl().find('#ledTagSlider')
      }

      return $('#ledTagSlider')
    },
    popIdSliderEl () {
      if (this.isMediaListModalVisible()) {
        return this.mediaListEl().find('#popIdentifierSlider')
      }

      return $('#popIdentifierSlider')
    },
    mediaListEl () {
      return $('#mediaList')
    },
    pageWhiteEl () {
      return $('.page.white')
    },
    popIdsSliderPresentationEl () {
      return this.popIdSliderEl().find('#popIdsSliderPresentation')
    },
    ledTagSliderPresentationEl () {
      return this.ledSliderEl().find('#ledTagsSliderPresentation')
    },
    isTagSliderHasData () {
      return this.tagsSliderPresentationEl().length && this.tagsSliderPresentationEl().hasClass('has-data')
    },
    isLedTagSliderHasData () {
      return this.ledTagSliderPresentationEl().length && this.ledTagSliderPresentationEl().hasClass('has-data')
    },
    isPopIdSliderHasData () {
      return this.popIdsSliderPresentationEl().length && this.popIdsSliderPresentationEl().hasClass('has-data')
    },
    tagsSliderPresentationEl () {
      return this.tagSliderEl().find('#tagsSliderPresentation')
    },
    getWhiteContentHeight () {
      if (this.isMediaListModalVisible()) {
        return this.mediaListEl().height()
      }

      return this.pageWhiteEl().height()
    },
    getTopOptionsElHeight () {
      if (this.isMediaListModalVisible()) {
        return 67
      }

      return this.pageWhiteEl().find('.options').length ? this.pageWhiteEl().find('.options')[0].clientHeight : 100
    },
    getTopOptionsElInnerHeight () {
      if (this.isMediaListModalVisible()) {
        return 67
      }

      return this.pageWhiteEl().find('.options').length ? this.pageWhiteEl().find('.options').height() : 0
    },
    getTotalHeightAllTopSlider () {
      let totalHeight = 0

      $('.top-slider-filter').each((indx, el) => {
        totalHeight += $(el).height()
      })

      return totalHeight
    },
    getTagSliderElHeight () {
      return this.tagSliderEl().length ? this.tagSliderEl().height() : 0
    },
    getTagSliderElDefaultHeight () {
      return this.tagSliderEl().length ? parseInt(this.tagSliderEl().attr('data-elheight')) : 0
    },
    getPopIdSliderElHeight () {
      return this.popIdSliderEl().length ? this.popIdSliderEl().height() : 0
    },
    getPopIdSliderElDefaulHeight () {
      return this.popIdSliderEl().length ? parseInt(this.popIdSliderEl().attr('data-elheight')) : 0
    },
    getOneThirdOfWhiteContent () {
      if (this.isMediaListModalVisible()) {
        return this.mediaListEl().height() / 3
      }

      return this.pageWhiteEl().height() / 3
    },
    /**
     * A hook function when clicking dropdown icon in each component.
     * It will send a global event and listen the event in onMount function as this is a mixin and used by different component.
     */
    handleExpandComponentIconClick () {
      // Media tags slider
      if (this.componentName === this.componentNames.TAGS_SLIDER) {
        if (this.lockedMediaTagsExpandAction) return

        if (this.expanded) {
          EventBus.$emit('COMPRESS_TAG_SLIDER', {})
        } else {
          EventBus.$emit('EXPAND_TAG_SLIDER', {})
        }
      }

      // PopId slider
      if (this.componentName === this.componentNames.POPID_SLIDER) {
        if (this.lockedPopIdExpandAction) return

        if (this.expanded) {
          EventBus.$emit('COMPRESS_POPID_SLIDER', {})
        } else {
          EventBus.$emit('EXPAND_POPID_SLIDER', {})
        }
      }

      // LED Tags slider
      if (this.componentName === this.componentNames.LED_TAGS_SLIDER) {
        if (this.lockedLedTagsExpandAction) return

        if (this.expanded) {
          EventBus.$emit('COMPRESS_LED_TAG_SLIDER', {})
        } else {
          EventBus.$emit('EXPAND_LED_TAG_SLIDER', {})
        }
      }
    },
    /**
     * Handles tag/popid selection from other components.
     * Returns the selected items indices
     */
    handleItemsSelection (params) {
      if (params.newItems.length) {
        const selectedItemsIndx = []

        for (const newItem of params.newItems) {
          const getItemIndx = params.items.findIndex(t => t.value === newItem)

          if (getItemIndx >= 0) {
            selectedItemsIndx.push(getItemIndx)
          }
        }

        if (params.default) {
          return selectedItemsIndx
        }
      } else {
        params.saveAction([])
        return []
      }
    },
    /**
     * A function to add classname as a flag to hide tags that is not selected when dragging.
     * When dragging, the tags wrapper will cover the entire content and tags that are not selected overlaps in some elements in content section.
     */
    addTagClassnameToHideOnDragging () {
      const addElClass = (regularItemClassName, ledPageItemClassname, itemMarginBottom, regularSliderPresentationHeight, ledPageSliderPresentationHeight) => {
        // Deduct the margin bottom from height to compare only with the actual element height of the tagSliderPresentation (tags outer container)
        const tagSliderMarginBottom = 10
        const targetSliderPresentationHeight = regularSliderPresentationHeight - tagSliderMarginBottom

        $(`.${regularItemClassName}`).each((indx, el) => {
          const tagTopOffset = $(el)[0].offsetTop + itemMarginBottom

          if (tagTopOffset > targetSliderPresentationHeight) {
            $(el).addClass('hide-while-draggging')
          } else {
            $(el).removeClass('hide-while-draggging')
          }
        })
      }

      addElClass('el-tag-tagSlider', 'led-dimension', 0, $('#tagsSliderPresentation').height(), $('.ledPageMediaTags').find('#tagsSliderPresentation').height()) // Tags
      addElClass('el-tag-popId', 'el-tag-ledPage', 5, $('#popIdentifierSlider').height(), $('#popIdentifierSlider').height()) // PopIds
    },
    updateTagSliderItemAnimation ({ animate }) {
      $('.el-tag-tagSlider').each((indx, el) => {
        if (animate) {
          if ($(el)[0].offsetTop > 2) {
            $(el).addClass('animated fadeIn')
          }
        } else {
          $(el).removeClass('animated fadeIn')
        }
      })
    },
    updatePopIdSliderItemAnimation ({ animate }) {
      $('.el-tag-popId').each((indx, el) => {
        if (animate) {
          if ($(el)[0].offsetTop > 5) {
            $(el).addClass('animated fadeIn')
          }
        } else {
          $(el).removeClass('animated fadeIn')
        }
      })
    },
    updateLedTagSliderItemAnimation ({ animate }) {
      $('.el-tag.led-dimension').each((indx, el) => {
        if (animate) {
          if ($(el)[0].offsetTop > 5) {
            $(el).addClass('animated fadeIn')
          }
        } else {
          $(el).removeClass('animated fadeIn')
        }
      })
    },
    updateSliderPresentationElHeight (params = {}) {
      let newContentElHeight = this.getWhiteContentHeight() / 3 // Get three fourth of white area as the max height of dropdown content by default
      let targetDataContentHeight = null // Get dropdown content height
      let targetSliderPresentationEl = null // Slider Presentation Element to be updated

      // For Tags Slider
      if (params.tagSlider) {
        targetDataContentHeight = $('#tagSliderContent').height()
        targetSliderPresentationEl = this.tagsSliderPresentationEl()
      }

      // For PopId Slider
      if (params.popIdSlider) {
        targetDataContentHeight = $('#popIdentifierSliderContent').height()
        targetSliderPresentationEl = this.popIdsSliderPresentationEl()
      }

      // For LED Page Tag Slider
      if (params.ledPageTagSlider) {
        targetDataContentHeight = $('#ledTagSliderContent').height()
        targetSliderPresentationEl = this.ledTagSliderPresentationEl()
      }

      // If dropdown content height is less than max height then use it with 20px margin bottom
      if (targetDataContentHeight < newContentElHeight) {
        newContentElHeight = targetDataContentHeight + 20
      }

      // Update tag slider presentation element style height
      targetSliderPresentationEl.attr('style', `height: ${newContentElHeight}px !important`)
    },
    handleTagSliderComponentActions (params = {}) {
      // Return if this mixin is not being used by tags slider component OR no data
      if (this.componentName !== this.componentNames.TAGS_SLIDER || !this.isTagSliderHasData()) return

      // Expand element
      if (params.expand) {
        this.expanded = true
        this.updateSliderPresentationElHeight({ tagSlider: true })
        this.updateTagSliderItemAnimation({ animate: true })
      } else { // Compress element
        this.expanded = false
        this.tagsSliderPresentationEl().scrollTop(0)
        this.tagsSliderPresentationEl().removeAttr('style')
        this.updateTagSliderItemAnimation({ animate: false })
      }
    },
    handlePopIdSliderComponentActions (params = {}) {
      // Return if this mixin is not being used by popId slider component OR no data
      if (this.componentName !== this.componentNames.POPID_SLIDER || !this.isPopIdSliderHasData()) return
      let popIdTopPosition = this.getTopOptionsElHeight() + this.getTagSliderElHeight()

      if (this.accessorComponent === this.componentNames.MEDIA_PICKER) {
        const mediaListItemContainerOffset = 60
        popIdTopPosition = mediaListItemContainerOffset + this.getTagSliderElHeight()
      }

      // Expand element
      if (params.expand) {
        this.expanded = true
        this.updateSliderPresentationElHeight({ popIdSlider: true })
        this.updatePopIdSliderItemAnimation({ animate: true })
      } else {
        this.expanded = false
        this.popIdsSliderPresentationEl().scrollTop(0)
        this.popIdsSliderPresentationEl().removeAttr('style')
        this.popIdSliderEl().addClass('animate-topPosition-changed')
        this.updatePopIdSliderItemAnimation({ animate: false })
      }

      this.popIdSliderEl().css({ top: `${popIdTopPosition}px` })
    },
    handleLedTagSliderComponentActions (params = {}) {
      // Return if this mixin is not being used by popId slider component OR no data
      if (this.componentName !== this.componentNames.LED_TAGS_SLIDER || !this.isLedTagSliderHasData()) return
      const popLedTagTopPosition = `${this.getTopOptionsElHeight() + this.getTagSliderElHeight() + this.getPopIdSliderElHeight()}`

      // Expand element
      if (params.expand) {
        this.expanded = true
        this.updateSliderPresentationElHeight({ ledPageTagSlider: true })
        this.updateLedTagSliderItemAnimation({ animate: true })
      } else {
        this.expanded = false
        this.ledTagSliderPresentationEl().scrollTop(0)
        this.ledTagSliderPresentationEl().removeAttr('style')
        this.ledSliderEl().addClass('animate-topPosition-changed')
        this.updateLedTagSliderItemAnimation({ animate: false })
      }

      this.ledSliderEl().css({
        top: `${popLedTagTopPosition}px`
      })
    },
    updateMainContent () {
      if (this.isMediaListModalVisible()) {
        // Update media-content style in media list modal
        if (this.accessorComponent === this.componentNames.MEDIA_PICKER) {
          this.$utils.updatePageComponentStyle({
            name: this.accessorComponent,
            animateMediaListModalContent: true
          })
        }
      } else {
        // Update media-content style in the current page
        const mainContentEl = $('.main-content-row')
        const currentMarginTop = mainContentEl.css('marginTop') ? parseFloat(mainContentEl.css('marginTop')) : 0
        const mainContentClassList = mainContentEl.attr('class').split(/\s+/)
        const gapLastSliderAndMainContent = 24
        let newMarginTop = this.getTotalHeightAllTopSlider()
        let newMainContentHeight = this.getWhiteContentHeight() - (this.getTopOptionsElHeight() + newMarginTop)

        // Handle added margin in admin page
        // Need to account for additional top margin for admin page sub header (See AdminPageHeader.vue) which is mt-8 (32px)
        if (this.pageWhiteEl().attr('id') === 'adminPage') {
          newMainContentHeight = newMainContentHeight - 32
        }

        // Add margin from last slider
        if (mainContentClassList.includes('reporting-content-row')) {
          newMarginTop = this.getTotalHeightAllTopSlider() + gapLastSliderAndMainContent
          newMainContentHeight = this.getWhiteContentHeight() - (this.getTopOptionsElHeight() + newMarginTop)
        }

        mainContentEl.addClass('animate-marginTop-changed')
        mainContentEl.css({
          marginTop: `${newMarginTop}px`
        })

        // Add timeOut in slideDown to remove flickr that the main content was cut
        if (newMarginTop > currentMarginTop) { // slideDown
          const animationTimeSetInCss = 500

          window.setTimeout(() => {
            mainContentEl.css({
              height: `${newMainContentHeight}px`
            })
          }, animationTimeSetInCss)
        } else { // slideUp
          mainContentEl.css({
            height: `${newMainContentHeight}px`
          })
        }
      }
    },
    validateExpandIconVisibility () {
      // Media tags slider
      if (this.componentName === this.componentNames.TAGS_SLIDER) {
        const iconVisibility = () => {
          const extraMarginBottomOfEachTag = 10
          const tagSliderContentHeight = $('#tagSliderContent').length ? $('#tagSliderContent').height() - extraMarginBottomOfEachTag : 0

          // Show icon if the tag items content is greater than the default slider height
          if (tagSliderContentHeight > this.commonExpandActionsDefaultSliderHeight) {
            this.showExpandIcon = true
          } else {
            this.showExpandIcon = false

            // Close the slider
            if (this.expanded) {
              this.handleTagSliderComponentActions({ expand: false })
              this.updateMainContent()
              this.addTagClassnameToHideOnDragging()
            }
          }
        }

        /**
          * If expanded, add a timeout to get the updated height of the slider because of some animations.
          * This usually happens when removing a tag.
        */
        if (this.expanded && !this.isMediaListModalVisible()) {
          this.lockedMediaTagsExpandAction = true

          window.setTimeout(() => {
            this.updateSliderPresentationElHeight({ tagSlider: true })
            iconVisibility()
            this.$utils.updatePageComponentStyle({ name: this.accessorComponent, validateExpandIconVisibility: true })
            this.lockedMediaTagsExpandAction = false
          }, 1200)
        } else {
          iconVisibility()
        }
      }

      // PopId Slider
      if (this.componentName === this.componentNames.POPID_SLIDER) {
        const iconVisibility = () => {
          const extraMarginBottomOfEachTag = 5
          const popIdentifierSliderContentElHeight = $('#popIdentifierSliderContent').length ? $('#popIdentifierSliderContent').height() - extraMarginBottomOfEachTag : 0

          // Set arrow visibility value
          if (popIdentifierSliderContentElHeight > this.commonExpandActionsDefaultSliderHeight) {
            this.showExpandIcon = true
          } else {
            this.showExpandIcon = false

            // Close the slider
            if (this.expanded) {
              this.handlePopIdSliderComponentActions({ expand: false })
              this.updateMainContent()
              this.addTagClassnameToHideOnDragging()
            }
          }
        }

        /**
          * If expanded, add a timeout to get the updated height of the slider because of some animations.
          * This usually happens when removing a tag.
        */
        if (this.expanded && !this.isMediaListModalVisible()) {
          this.lockedPopIdExpandAction = true
          window.setTimeout(() => {
            this.updateSliderPresentationElHeight({ popIdSlider: true })
            iconVisibility()
            this.$utils.updatePageComponentStyle({ name: this.accessorComponent, validateExpandIconVisibility: true })
            this.lockedPopIdExpandAction = false
          }, 1200)
        } else {
          iconVisibility()
        }
      }

      // For Led Tags slider
      if (this.componentName === this.componentNames.LED_TAGS_SLIDER) {
        const iconVisibility = () => {
          const extraMarginBottomOfEachTag = 5
          const ledTagSliderContentElHeight = $('#ledTagSliderContent').length ? $('#ledTagSliderContent').height() - extraMarginBottomOfEachTag : 0

          // Set arrow visibility value
          if (ledTagSliderContentElHeight > this.commonExpandActionsDefaultSliderHeight) {
            this.showExpandIcon = true
          } else {
            this.showExpandIcon = false

            // Close the slider
            if (this.expanded) {
              this.handleLedTagSliderComponentActions({ expand: false })
              this.updateMainContent()
              this.addTagClassnameToHideOnDragging()
            }
          }
        }

        /**
          * If expanded, add a timeout to get the updated height of the slider because of some animations.
          * This usually happens when removing a tag.
        */
        if (this.expanded && !this.isMediaListModalVisible()) {
          this.lockedLedTagsExpandAction = true
          window.setTimeout(() => {
            this.updateSliderPresentationElHeight({ ledPageTagSlider: true })
            iconVisibility()
            this.$utils.updatePageComponentStyle({ name: this.accessorComponent, validateExpandIconVisibility: true })
            this.lockedLedTagsExpandAction = false
          }, 1200)
        } else {
          iconVisibility()
        }
      }
    },
    compressAllSlider () {
      this.handleTagSliderComponentActions({ expand: false })
      this.handlePopIdSliderComponentActions({ expand: false })
      this.handleLedTagSliderComponentActions({ expand: false })
    },
    listenGlobalEvents () {
      // Listen tag slider expand event
      EventBus.$on('EXPAND_TAG_SLIDER', (payLoad) => {
        this.handlePopIdSliderComponentActions({ expand: false })
        this.handleLedTagSliderComponentActions({ expand: false })
        this.handleTagSliderComponentActions({ expand: true })

        window.setTimeout(() => {
          this.updateMainContent()
          this.validateExpandIconVisibility()
          this.addTagClassnameToHideOnDragging()
        }, 20)
      })

      // Listen tag slider compress event
      EventBus.$on('COMPRESS_TAG_SLIDER', (payLoad) => {
        this.handleTagSliderComponentActions({ expand: false })
        this.validateExpandIconVisibility()

        window.setTimeout(() => {
          this.handlePopIdSliderComponentActions({ expand: false })
          this.handleLedTagSliderComponentActions({ expand: false })
          this.updateMainContent()
          this.addTagClassnameToHideOnDragging()
        }, 20)
      })

      // Listen popId slider expand event
      EventBus.$on('EXPAND_POPID_SLIDER', (payLoad) => {
        this.handleTagSliderComponentActions({ expand: false })
        this.handleLedTagSliderComponentActions({ expand: false })
        this.handlePopIdSliderComponentActions({ expand: true })
        this.validateExpandIconVisibility()

        window.setTimeout(() => {
          this.updateMainContent()
          this.addTagClassnameToHideOnDragging()
        }, 20)
      })

      // Listen popId slider compress event
      EventBus.$on('COMPRESS_POPID_SLIDER', (payLoad) => {
        this.handlePopIdSliderComponentActions({ expand: false })
        this.handleLedTagSliderComponentActions({ expand: false })
        this.validateExpandIconVisibility()

        window.setTimeout(() => {
          this.updateMainContent()
          this.addTagClassnameToHideOnDragging()
        }, 20)
      })

      // Listen led tag slider expand event
      EventBus.$on('EXPAND_LED_TAG_SLIDER', (payLoad) => {
        this.handleTagSliderComponentActions({ expand: false })
        this.handlePopIdSliderComponentActions({ expand: false })
        this.handleLedTagSliderComponentActions({ expand: true })
        this.validateExpandIconVisibility()

        window.setTimeout(() => {
          this.updateMainContent()
        }, 20)
      })

      // Listen led tag slider compress event
      EventBus.$on('COMPRESS_LED_TAG_SLIDER', (payLoad) => {
        this.handleTagSliderComponentActions({ expand: false })
        this.handleLedTagSliderComponentActions({ expand: false })
        this.validateExpandIconVisibility()

        window.setTimeout(() => {
          this.updateMainContent()
        }, 20)
      })

      // Listen Media Picker on close event
      EventBus.$on('MEDIA_PICKER_CLOSED', (payLoad) => {
        this.compressAllSlider()
      })
    }
  },
  mounted () {
    this.listenGlobalEvents()
  }
}
